import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import {
  Header,
  Icon,
  Loader,
  Segment,
  Grid,
  Container,
  Tab,
} from 'semantic-ui-react';

import { useFetchEvaluationSessionByIdQuery } from './evaluationSessionApiSlice';
import ChatSessionDetail from '../chat_sessions/ChatSessionDetail';
import EvaluatedCriteria from './EvaluatedCriteria';
import EvaluationSummary from './EvaluationSummary';
import '../../components/SharedCard.css';

const EvaluationDetail = () => {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const queryParams = new URLSearchParams(location.search);
  const evaluation_session_pk = queryParams.get('evaluation_session');

  console.log(evaluation_session_pk);
  // GET list
  const { data, isLoading, isSuccess } = useFetchEvaluationSessionByIdQuery(
    evaluation_session_pk
  );
  // GET by ID and make it accessible by variable evaluation_session_detail

  let content;
  if (isLoading) {
    content = <Loader active />;
  } else if (isSuccess) {
    const panes = [
      {
        menuItem: '응대 세션 로그',
        render: () => (
          <Tab.Pane
            style={{
              height: isMobile ? 'auto' : 'calc(100vh - 220px)',
              overflowY: isMobile ? 'visible' : 'auto',
              padding: 0,
              border: 'none',
              boxShadow: 'none',
            }}
          >
            <div style={{ padding: '20px' }}>
              <ChatSessionDetail chat_session_id={data.chat_session.id} />
            </div>
          </Tab.Pane>
        ),
      },
      {
        menuItem: '채점 내용',
        render: () => (
          <Tab.Pane
            style={{
              height: isMobile ? 'auto' : 'calc(100vh - 220px)',
              overflowY: isMobile ? 'visible' : 'auto',
              padding: 0,
              border: 'none',
              boxShadow: 'none',
            }}
          >
            <div style={{ padding: '20px' }}>
              <EvaluatedCriteria
                evaluatedcriterion_set={data.evaluatedcriterion_set}
              />
            </div>
          </Tab.Pane>
        ),
      },
      {
        menuItem: '요약',
        render: () => (
          <Tab.Pane
            style={{
              height: isMobile ? 'auto' : 'calc(100vh - 220px)',
              overflowY: isMobile ? 'visible' : 'auto',
              padding: 0,
              border: 'none',
              boxShadow: 'none',
            }}
          >
            <div style={{ padding: '20px' }}>
              <EvaluationSummary evaluationsession={data} />
            </div>
          </Tab.Pane>
        ),
      },
    ];

    content = (
      <div
        style={{
          height: 'auto',
          display: 'flex',
          flexDirection: 'column',
          overflow: isMobile ? 'visible' : 'hidden',
        }}
      >
        {/* Header Section */}
        <div
          style={{
            flex: '0 0 auto',
            padding: '16px 0',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(20px)',
            borderBottom: '1px solid rgba(0,0,0,0.05)',
          }}
        >
          <Container fluid>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '0 20px',
              }}
            >
              <div
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: '#F2F2F7',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Icon
                  name="file alternate outline"
                  style={{ margin: 0, color: '#007AFF', fontSize: '18px' }}
                />
              </div>
              <div>
                <h2
                  style={{
                    fontSize: '17px',
                    fontWeight: '600',
                    margin: 0,
                    color: '#1d1d1f',
                  }}
                >
                  평가 상세 보고서
                </h2>
                <p style={{ fontSize: '13px', color: '#86868b', margin: 0 }}>
                  채팅 로그, 평가 항목 및 요약 정보
                </p>
              </div>
            </div>
          </Container>
        </div>

        <Container fluid style={{ padding: isMobile ? '0' : '20px', flex: 1 }}>
          {isMobile ? (
            <Tab
              menu={{
                secondary: true,
                pointing: true,
                widths: 3,
                style: {
                  display: 'flex',
                  justifyContent: 'center',
                  flexWrap: 'nowrap',
                  position: 'sticky',
                  top: '48px',
                  background: 'white',
                  zIndex: 10,
                  marginBottom: 0,
                },
              }}
              panes={panes}
              style={{ height: '100%' }}
            />
          ) : (
            <Grid columns={3} stackable>
              <Grid.Column width={4}>
                <div
                  className="custom-card"
                  style={{ height: 'calc(100vh - 170px)', padding: ' 0' }}
                >
                  <div
                    className="custom-card-header"
                    style={{ paddingTop: '20px', paddingLeft: '20px' }}
                  >
                    <Icon
                      name="comments outline"
                      style={{ color: '#86868b' }}
                    />
                    <h3
                      className="custom-card-title"
                      style={{ marginLeft: '8px' }}
                    >
                      응대 세션 로그
                    </h3>
                  </div>
                  <div style={{ flex: 1, overflowY: 'auto' }}>
                    <div style={{ padding: '0 20px' }}>
                      <ChatSessionDetail
                        chat_session_id={data.chat_session.id}
                      />
                    </div>
                  </div>
                </div>
              </Grid.Column>

              <Grid.Column width={6}>
                <div
                  className="custom-card"
                  style={{ height: 'calc(100vh - 170px)', padding: ' 0' }}
                >
                  <div
                    className="custom-card-header"
                    style={{ paddingTop: '20px', paddingLeft: '20px' }}
                  >
                    <Icon name="tasks" style={{ color: '#86868b' }} />
                    <h3
                      className="custom-card-title"
                      style={{ marginLeft: '8px' }}
                    >
                      채점 내용
                    </h3>
                  </div>
                  <div
                    style={{
                      flex: 1,
                      overflowY: 'auto',
                      overflowX: 'hidden',
                      padding: '0 0px',
                    }}
                  >
                    <div style={{ padding: '20px 20px' }}>
                      <EvaluatedCriteria
                        evaluatedcriterion_set={data.evaluatedcriterion_set}
                      />
                    </div>
                  </div>
                </div>
              </Grid.Column>

              <Grid.Column width={6}>
                <div
                  className="custom-card"
                  style={{ height: 'calc(100vh - 170px)', padding: ' 0' }}
                >
                  <div
                    className="custom-card-header"
                    style={{ paddingTop: '20px', paddingLeft: '20px' }}
                  >
                    <Icon name="file alternate" style={{ color: '#86868b' }} />
                    <h3
                      className="custom-card-title"
                      style={{ marginLeft: '8px' }}
                    >
                      요약
                    </h3>
                  </div>
                  <div
                    style={{
                      flex: 1,
                      overflowY: 'auto',
                      overflowX: 'hidden',
                      padding: '0 0px',
                    }}
                  >
                    <div style={{ padding: '0 20px' }}>
                      <EvaluationSummary evaluationsession={data} />
                    </div>
                  </div>
                </div>
              </Grid.Column>
            </Grid>
          )}
        </Container>
      </div>
    );
  }
  return content;
};

export default EvaluationDetail;
